export default __webpack_public_path__ + "static/media/A6.4676ad98.png";